<template>
    <div class="ur-data-grid__content__cell ur-data-grid__content__cell--accordion"
            :style="tdStyle" @click="checkRow">
        <div class="ur-data-grid__content__cell__value" :style="valueStyle">
            <ur-icon class="ur-data-grid__content__cell--accordion--icon" :class="checkClass" 
                    icon="expand_menu" iconType="picto"/>
        </div>
    </div>
</template>

<script>
export default {
    name : 'urDataGridContentAccordionCell',
    inject : ['gridInfo','rowInfo'],
    props : {
        value : null, /* type any */
        vertical : {type:Boolean},
        slide    : {type:Boolean}
    },
    computed : {
        isRowAccord() {
            var opsAcc = this.gridInfo.opts.accordion;
            if(typeof opsAcc === 'function') {
                return opsAcc(this.rowInfo.row);
            } else {
                return !!opsAcc;
            }
        },
        tdStyle() {
            let style = {};
            style['height'] = this.gridInfo.opts.rowHeight+"px";
            var width = this.gridInfo.opts.accordionColumnWidth;
            if(!this.vertical) width+= 10; // @see also HeaderRow.vue -> accordWidth
            style['flex'] = '0 0 '+width+'px';
            style['min-width'] = '0px';
            return style;
        },
        valueStyle() {return {}},
        checkClass() {
            var clazz = [];
            // 1. direction
            if(this.vertical) {
                clazz.push('ur-data-grid__content__cell--accordion--vertical')
            } else if(this.slide) {
                clazz.push('ur-data-grid__content__cell--accordion--slide')
            }
            // 2. status : expand
            if(this.value) {
                clazz.push('ur-data-grid__content__cell--accordion--expand')
            }
            // 3. hide if accord check fail
            if(!this.isRowAccord) {
                clazz.push('ur-data-grid__content__cell--accordion--prevent')
            }
            return clazz
        }
    },
    methods: {
        checkRow(e) {
            if(!this.isRowAccord) return;
            this.$emit('input',!this.value)
        }
    }
}

</script>

